export function isValidInstance(error: unknown) {
  return error instanceof Error;
}
